import { FieldErrors } from 'react-hook-form'
import get from 'lodash/get'
import * as yup from 'yup'
import { REQUIRED_MESSAGE } from '../../../constants'

export const SmartWayCarrierSchema = yup.object({
  isRegistered: yup.boolean().required(REQUIRED_MESSAGE),
  /**
   * @example '2023-04-12T15:00:00.000Z'
   */
  renewalDate: yup
    .date()
    .nullable()
    .when('isRegistered', {
      is: true,
      then: yup.date().required(REQUIRED_MESSAGE),
    }),
})

export type TSmartWayCarrierSchema = yup.InferType<typeof SmartWayCarrierSchema>

export const getErrorMessage = <T extends FieldErrors<TSmartWayCarrierSchema>, K extends keyof T>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}
